export const blockIconsTransportationTransportationNew = (
	<span className='material-symbols-outlined'>transportation</span>
);
